import React from "react";

function LandingHeader() {
    return (
        <header className="sticky top-0 z-50 bg-white border-b border-[#e5e5e5]">
            <div className="max-w-[1200px] mx-auto px-4 py-3 flex items-center justify-between gap-6 flex-wrap md:flex-nowrap">
                <div className="flex items-center gap-6 flex-wrap">
                    <div className="flex items-center gap-1 font-bold text-[20px]">
                        <span className="text-[#222222]">Agroland.kz</span>
                    </div>

                    <nav
                        className="flex items-center gap-2 flex-wrap text-sm"
                        aria-label="Главная навигация"
                    >
                        {[
                            "О компании",
                            "Продукты",
                            "Новости и статьи",
                        ].map((item, index) => (
                            <button
                                key={item}
                                className={`px-3 py-1 rounded-full text-[14px] transition ${
                                    index === 0
                                        ? "bg-[#147F26]/10 text-[#111111]"
                                        : "text-[#555555] hover:bg-[#147F26]/10"
                                }`}
                            >
                                {item}
                            </button>
                        ))}
                    </nav>
                </div>

                <div className="flex items-center gap-3 flex-wrap md:flex-nowrap">
                    <div className="relative">
                        <input
                            type="text"
                            className="rounded-full border border-[#e0e0e0] px-4 py-1.5 text-sm min-w-[140px] placeholder:text-[#b0b0b0] focus:outline-none focus:border-[#147F26]"
                            placeholder="Поиск"
                        />
                    </div>

                    <div className="flex items-center bg-[#147F26]/10 rounded-full p-1">
                        <button className="px-3 py-1 text-[13px] rounded-full bg-white text-[#147F26]">
                            Рус
                        </button>
                        <button className="px-3 py-1 text-[13px] rounded-full text-[#555555]">
                            Қаз
                        </button>
                    </div>

                    <button className="px-4 py-1.5 rounded-full border border-[#147F26] bg-white text-sm text-[#147F26] hover:bg-[#147F26]/5 hover:border-[#147F26]">
                        Войти
                    </button>
                </div>
            </div>
        </header>
    );
}

export default LandingHeader;

